import { createOssAssetsUrl } from '@/utils/createOssAssetsUrl';

export const IMAGE_404 = createOssAssetsUrl('/assets/img/cms-web/404.svg');
